




















import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class OperationModal extends Vue {
  @Prop({ type: Object, required: false }) private btnObj!: any;
  @Prop({ type: Boolean, required: false }) private isShow!: boolean;
    private screenHight: any;
    private marginTopTips: string = '';
    private textModal: string = '';

    private mounted() {
        this.screenHight = document.documentElement.clientHeight;
        this.textModal = this.btnObj.initTextModal;
    }
    private sendMessage(item: any) {
        if ( item.slot === 'right' ) {
            this.$emit('confirm', this.textModal);
        } else {
            this.textModal = this.btnObj.initTextModal;
            this.$emit('cancel');
        }
    }

    @Watch('isShow')
    private onChangeValue(val: number, old: any) {
        const refelement = ( this.$refs.element as any );
        refelement.style.transform = 'translate3d(0%, ' + this.screenHight + 'px, 0)';
        this.marginTopTips = ( this.screenHight * 2 / 5 ) - (( refelement.getBoundingClientRect().height) / 2 ) + 'px';
        refelement.style.transform = 'translate3d(0%, ' + 0 + ', 0)';
    }
}
